import { withFields } from 'app-webtech-core/beacon/withFields';
import { channelGuideRequestBeacon } from './channelGuideRequest';
import { channelGuideLoadedBeacon } from './channelGuideLoaded';
import { FETCH_ALL } from '../actions/types';

export const linearChannelsEventDefinitionsMap = {
  [FETCH_ALL.REQUEST]: withFields(channelGuideRequestBeacon),
  [FETCH_ALL.SUCCESS]: withFields(channelGuideLoadedBeacon),
};
